//imgs
import img01 from "../../assets/images/chapters/08/01.jpg";
import img02 from "../../assets/images/chapters/08/02.jpg";
import img03 from "../../assets/images/chapters/08/03.jpg";
import img04 from "../../assets/images/chapters/08/04.jpg";
import img05 from "../../assets/images/chapters/08/05.jpg";

import img06 from "../../assets/images/chapters/08/06.jpg";
import img07 from "../../assets/images/chapters/08/07.jpg";
import img08 from "../../assets/images/chapters/08/08.jpg";

import img09 from "../../assets/images/chapters/08/09.jpg";
import img10 from "../../assets/images/chapters/08/10.jpg";
import img11 from "../../assets/images/chapters/08/11.jpg";

import img12 from "../../assets/images/chapters/08/12.jpg";
import img13 from "../../assets/images/chapters/08/13.jpg";
import img14 from "../../assets/images/chapters/08/14.jpg";

import { captions } from "../../assets/data/chapters/chapter08";

//scroll reveal
import ScrollReveal from "../scrollReveal";

const Chapter = () => {
  return (
    <div id="chapter08">
      <div className="group01">
        <ScrollReveal className="title">
          <span>ONE</span>
        </ScrollReveal>
        <ScrollReveal className="title">
          <span>GIANT</span>
        </ScrollReveal>
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img01} />
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img02} />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img03} />
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img04} />
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img05} />
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group02">
        <ScrollReveal className="title">
          <span className="dash"></span>
          <span className="dash"></span>
          <span>LEAP</span>
        </ScrollReveal>
        <div className="row">
          <ScrollReveal className="picture">
            <img src={img06} />
            <p className="caption">{captions[0]}</p>
          </ScrollReveal>
          <ScrollReveal className="picture">
            <img src={img07} />
            <p className="caption">{captions[1]}</p>
          </ScrollReveal>

          <ScrollReveal className="picture">
            <img src={img08} />
            <p className="caption">{captions[2]}</p>
          </ScrollReveal>
        </div>
      </div>

      <div className="group03">
        <ScrollReveal className="title">FOR</ScrollReveal>
        <div className="row">
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img09} />
              <p className="caption">{captions[3]}</p>
            </ScrollReveal>
          </div>
          <div className="column">
            <ScrollReveal className="picture">
              <img src={img10} />
              <p className="caption">{captions[4]}</p>
            </ScrollReveal>
            <ScrollReveal className="picture">
              <img src={img11} />
              <p className="caption">{captions[5]}</p>
            </ScrollReveal>
          </div>
        </div>
      </div>

      <div className="group04">
        <ScrollReveal className="title">
          <span>mankind</span>
        </ScrollReveal>
        <div className="column">
          <ScrollReveal className="picture">
            <img src={img12} />
          </ScrollReveal>

          <ScrollReveal className="picture">
            <img src={img13} />
            <p className="caption">{captions[6]}</p>
          </ScrollReveal>
          <ScrollReveal className="picture">
            <img src={img14} />
            <p className="caption">{captions[7]}</p>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
};

export default Chapter;
